/**
 * @memberOf app
 * @ngdoc module
 * @description Module that is used for the main page that the users sees, listing all results.
 * @name app.home
 */


import './home.css';
import routing from './home.route';
import HomeController from './home.controller';
import UserService from '../services/user.service';
import ReportService from '../services/report.service';
import AuthService from '../services/auth.service';

export default angular.module('app.home', [UserService, ReportService, AuthService])
  .config(routing)
  .controller('HomeController', HomeController)
  .name;



// WEBPACK FOOTER //
// ./src/client/app/home/home.module.js